interface PhoneIconProps {
  className?: string;
}

export const PhoneIcon = ({ className }: PhoneIconProps) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 256 256"
  >
    <g
      style={{
        stroke: "none",
        strokeWidth: 0,
        strokeDasharray: "none",
        strokeLinecap: "butt",
        strokeLinejoin: "miter",
        strokeMiterlimit: 10,
        fill: "none",
        fillRule: "nonzero",
        opacity: 1,
      }}
      transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
    >
      <linearGradient
        id="SVGID_1"
        gradientUnits="userSpaceOnUse"
        x1="45"
        y1="87.6137"
        x2="45"
        y2="2.8385"
      >
        <stop offset="0%" style={{ stopColor: "rgb(3,182,33)", stopOpacity: 1 }} />
        <stop
          offset="100%"
          style={{ stopColor: "rgb(100,252,126)", stopOpacity: 1 }}
        />
      </linearGradient>
      <path
        d="M 71.172 90 H 18.828 C 8.43 90 0 81.57 0 71.172 V 18.828 C 0 8.43 8.43 0 18.828 0 h 52.343 C 81.57 0 90 8.43 90 18.828 v 52.343 C 90 81.57 81.57 90 71.172 90 z"
        style={{
          stroke: "none",
          strokeWidth: 1,
          strokeDasharray: "none",
          strokeLinecap: "butt",
          strokeLinejoin: "miter",
          strokeMiterlimit: 10,
          fill: "url(#SVGID_1)",
          fillRule: "nonzero",
          opacity: 1,
        }}
        transform=" matrix(1 0 0 1 0 0) "
        strokeLinecap="round"
      />
      <path
        d="M 52.793 57.122 l 6.785 -2.262 c 1.909 -0.636 4.004 -0.362 5.684 0.744 l 8.368 5.507 c 2.594 1.707 3.237 5.233 1.414 7.747 l -3.785 5.217 c -6.578 6.578 -23.7 -3.967 -37.533 -17.8 s -24.378 -30.956 -17.8 -37.533 l 5.217 -3.785 c 2.513 -1.823 6.04 -1.179 7.747 1.414 l 5.507 8.368 c 1.106 1.681 1.38 3.776 0.744 5.684 l -2.262 6.785 c -0.501 1.504 -0.267 3.161 0.643 4.46 c 4.069 5.805 9.006 10.742 14.811 14.811 C 49.631 57.388 51.289 57.623 52.793 57.122 z"
        style={{
          stroke: "none",
          strokeWidth: 1,
          strokeDasharray: "none",
          strokeLinecap: "butt",
          strokeLinejoin: "miter",
          strokeMiterlimit: 10,
          fill: "rgb(255,255,255)",
          fillRule: "nonzero",
          opacity: 1,
        }}
        transform=" matrix(1 0 0 1 0 0) "
        strokeLinecap="round"
      />
    </g>
  </svg>
);
